import { Paperclip } from "react-bootstrap-icons";
import { openUsageReceiptDownload } from "../Data/UsageReceipt";
import { Hyperlink } from "./Hyperlink";

export function UsageReceiptDownloadButton( { receiptUrl }: { receiptUrl: string } ) {
  return (
    <Hyperlink onClick={() => openUsageReceiptDownload( receiptUrl )}>
      <Paperclip className="me-1 icon-shift-up" size={13} />
      View receipt
    </Hyperlink>
  );
}
